import { AnyAction } from 'redux';

import Dictionary from '../api/dictionary';
import TopNavigationMenuItem from '../api/topNavigationMenuEntity';
import { actionTypes } from '../common/constants/actionTypes';

export interface ITopNavState {
  isMobileNavigationVisible: boolean;
  topNavigationMenuItems: TopNavigationMenuItem[];
}

const initialState: ITopNavState = {
  isMobileNavigationVisible: false,
  topNavigationMenuItems: [],
};

// Make sure keys match your actual paths
const topNavigationUrls = new Dictionary([
  { key: '/ajankohtaista', value: { topNavigationItemId: 4 } },
  { key: '/pages/2',       value: { topNavigationItemId: 1 } },
  { key: '/sertifikaatit', value: { topNavigationItemId: 2 } },
]).toLookup();

export const topNavigationMenuItemReducer = (
  state: ITopNavState = initialState,
  action: AnyAction
): ITopNavState => {
  switch (action.type) {
    case actionTypes.FETCH_TOP_NAVIGATION_COMPLETED:
      return {
        ...state,
        isMobileNavigationVisible: false,
        topNavigationMenuItems: action.payload as TopNavigationMenuItem[],
      };

    case actionTypes.UPDATE_MOBILE_SUB_NAVIGATION: {
      const id = (action.payload && action.payload.id);
      return {
        ...state,
        topNavigationMenuItems: state.topNavigationMenuItems.map(mi => {
          // If your model uses string IDs, coerce both sides:
          // const same = String(mi.id) === String(id);
          const same = mi.id === id;
          return same ? { ...mi, isExpanded: !mi.isExpanded } : mi;
        }),
      };
    }

    case actionTypes.SET_TOP_NAVIGATION_ACTIVE_CSS: {
      const path = action.payload;
      if (typeof path !== 'string') {
        return state;
      }

      let selectedId: number | undefined;
      for (const key of Object.keys(topNavigationUrls)) {
        if (path.startsWith(key)) {
          selectedId = (topNavigationUrls as any)[key].topNavigationItemId;
          break;
        }
      }

      return {
        ...state,
        topNavigationMenuItems: state.topNavigationMenuItems.map(mi => {
          // If id is string in your model, coerce: const isSelected = selectedId != null && String(mi.id) === String(selectedId);
          const isSelected = selectedId != null && mi.id === selectedId;
          return { ...mi, additionalCssClass: isSelected ? 'selected' : '' };
        }),
      };
    }

    case actionTypes.MOBILE_NAVIGATION_CLICKED:
      return {
        ...state,
        isMobileNavigationVisible: !state.isMobileNavigationVisible,
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/topNavigationMenuItems.ts